import {ActionIcon, Group, Table, Text} from "@mantine/core";
import {IconEdit, IconTrash} from "@tabler/icons-react";
import type {LocalLibraryEntry} from "@/app/storage";

export function LibraryEntryRow(props: {
  entry: LocalLibraryEntry;
  onEdit: (entry: LocalLibraryEntry) => void;
  onDelete: (uri: string) => void;
}) {
  const {entry, onEdit, onDelete} = props;
  return (
    <Table.Tr key={entry.uri}>
      <Table.Td>
        <Text fw={700} size="md">
          {entry.content.expression}
        </Text>
        <Text size="xs" c="dimmed">
          {entry.content.readings?.[0]?.value || ""}
        </Text>
      </Table.Td>
      <Table.Td>{entry.content.meaning}</Table.Td>
      <Table.Td>
        <Group gap="xs" justify="flex-end">
          <ActionIcon variant="subtle" size="sm" onClick={() => onEdit(entry)}>
            <IconEdit size={16} />
          </ActionIcon>
          <ActionIcon
            variant="subtle"
            color="red"
            size="sm"
            onClick={() => onDelete(entry.uri)}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
}
